import { render, staticRenderFns } from "./FeeCalculationSetting.vue?vue&type=template&id=07a8f201"
import script from "./FeeCalculationSetting.vue?vue&type=script&lang=ts"
export * from "./FeeCalculationSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports